'use client';

import { usePathname } from 'next/navigation';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import BackToTop from '@/components/BackToTop';
import { getThemeMode } from '@/lib/theme-routes';

export default function MainLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const content = (
    <div className="relative flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <BackToTop />
    </div>
  );

  if (getThemeMode(pathname) === 'dark') {
    return (
      <div className="dark bg-background text-foreground transition-colors duration-300">
        {content}
      </div>
    );
  }

  return content;
}
